export const classes = {
  title: 'text-grey-9 font-aspekta',
  xl: 'text-5xl font-bold',
  lg: 'text-3xl font-bold',
  md: 'text-lg font-bold tracking-wide',
  sm: 'text-base font-bold',
  xs: 'text-sm font-bold text-grey-4 tracking-wide',
};
